import { Component, Input } from '@angular/core';
import { Passenger } from 'src/app/core/models/itinerary.model';

@Component({
  selector: 'app-passengers-resume',
  templateUrl: './passengers-resume.component.html'
})
export class PassengersResumeComponent {
  @Input() passengers: Passenger[];
}
